import GridView from './GridView';
import FavoritesView from './FavoritesView';
import ListView from './ListView';
import MapView from './MapView';
import FlexView from './FlexView';

module.exports = {
  GridView,
  FavoritesView,
  ListView,
  MapView,
  FlexView,
};



// WEBPACK FOOTER //
// ./src/ui/Views/Announcements/index.js